import {useState, useEffect} from 'react'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import { MdContentCopy } from 'react-icons/md'
import Div100vh from 'react-div-100vh'
import Footer from './components/Footer'
import BetaBanner from './components/BetaBanner'
import { OPTIONS } from './constants/options'

function App() {
  // set selection (i.e. twitter)
  const [selection, setSelection] = useState(OPTIONS[0].name)
  // track character limit field
  const [charLimit, setCharLimit] = useState(OPTIONS[0].charLimit)
  // track input
  const [body, setBody] = useState('')
  // track output
  const [existingMessages, setExistingMessages] = useState([])
  // track copy & paste
  const [isCopied, setIsCopied] = useState(false);

  const onCopyText = () => {
    setIsCopied(true);
    setTimeout(() => {
      setIsCopied(false);
    }, 1400);
  };

  // update charLimit based on selection
  useEffect(() => {
    let currentOption = OPTIONS.filter((option) => option.name === selection)
    setCharLimit(currentOption[0].charLimit)
  }, [selection])

  const onSubmit = (e) => {
    e.preventDefault();
    // clear current messages
    setExistingMessages([])
    // determine number of 'messages' based on charLimit & message/splitCount (-8 to account for splitCount up to 99 (i.e. ' (1/2)' is 6 characters, ' (10/11)' is 8 characters))
    const splitCount = Math.ceil(body.length/Number(charLimit - 8))
    // for the amount of messages, add the content from the original submission to the 'existingMessages' state
    for (let i = 0, c = 0; i < splitCount; i++, c += Number(charLimit - 8)) {
      const messageSlice = `${body.substring(c, c+Number(charLimit - 8)).trim()} (${i+1}/${splitCount})`
      setExistingMessages(existingMessages => [...existingMessages, messageSlice])
    }
    setBody('')
  }

  return (
    <Div100vh>
    <div className="flex h-full flex-col mx-auto sm:max-w-4xl px-1 pt-2 pb-2 sm:px-6 lg:px-8 short:pb-2 short:pt-2">
      {/* successful copy notification */}
      {isCopied && 
        <div className="fixed w-1/2 bottom-0 bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-10" role="alert">
          <strong className="font-bold">Text copied</strong>
        </div>
      }
      <BetaBanner />
      <div className="mx-auto flex w-full grow flex-col gap-2">
        <div className='grid justify-center content-center'>
          <span className='text-center align-middle text-2xl'>Splitter</span>
        </div>
        <div className="flex flex-col text-center">
          <span>Split your walls of text with a designated platform in mind; otherwise set a custom character limit.</span>
          <span>Your split items will include the current item number / total items.</span>
          <span>You can then copy them all together, or individually, and paste them directly in their destinations.</span>
        </div>
        <div className="grid grid-cols-3 gap-2 grid-rows-2">
          {/* selection menu */}
          <select className="col-span-2 w-full border rounded-md p-2" value={selection.name} onChange={(e) => setSelection(e.target.value)}>
            {OPTIONS.map((option) => (
              <option key={option.id} value={option.name}>{option.name}</option>
            ))
            }
          </select>
          {/* conditional for if custom is selected */}
          {selection === 'Custom' ? (
          <div>
            <label htmlFor="charLimit" className='sr-only'>Character Limit</label>
            <input name="charLimit" type="number" className="border w-full max-w-xs h-full rounded-md text-center p-2" id="search" placeholder="Character Limit" value={charLimit} onChange={(e) => setCharLimit(e.target.value)} />
          </div>
          ) : (
          <div>
            <label htmlFor="charLimit" className='sr-only'>Character Limit</label>
            <input disabled name="charLimit" type="number" className="input border w-full max-w-xs h-full rounded-md text-center p-2" id="search" placeholder="Character Limit" value={charLimit} onChange={(e) => setCharLimit(e.target.value)} />
          </div>
          )}
          <div className='col-span-3 flex flex-col justify-end'>
            <span className='self-end'>Number of Split Items: {Math.ceil((body.length + 8*(Math.ceil(body.length/charLimit)))/charLimit)}</span>
            <span className='self-end'>Current Characters: {body.length}/{charLimit}</span>
          </div>
        </div>
        {/* input */}
        <div>
          <form className='flex flex-col w-full' onSubmit={onSubmit}>
            <div className=''>
              <label htmlFor="message" className='sr-only'>Message</label>
              <textarea name="message" type="text" className="w-full border h-2/5 rounded-md p-2" id="message" placeholder='Insert body of text here' value={body} onChange={(e) => setBody(e.target.value)}></textarea>
            </div>
            <button className='btn btn-outline btn-border btn-secondary rounded-md p-2'>Submit</button>
          </form>
        </div>
        {/* output */}
        <div className='flex flex-col gap-2'>
          {existingMessages.length> 0 && 
          <div className="border px-4 py-3 rounded-md grid grid-cols-[1fr_40px]">
            <p>Copy all split content with line breaks</p>
            <div className='grid justify-center content-center'>
              <CopyToClipboard className='hover:cursor-pointer hover:text-secondary text-primary' text={existingMessages.join("\r\n \r\n")} onCopy={onCopyText}>
                <MdContentCopy />
              </CopyToClipboard>
            </div>
          </div>
          }
          {existingMessages.map((message, index, self) => {
            return <div className='white-space border rounded-md px-4 py-4 grid grid-cols-[1fr_40px]' key={index}>
              <div>
                {message}
              </div>
              <div className='grid justify-center content-center gap-2'>
                <div className='grid justify-center content-center'>
                  <CopyToClipboard className='hover:cursor-pointer hover:text-secondary text-primary' text={message} onCopy={onCopyText}>
                    <MdContentCopy />
                  </CopyToClipboard>
                </div>
                <div className='grid justify-center content-center'>
                <span className='text-sm'>{`${index+1}/${self.length}`}</span>
                </div>
              </div>
            </div>
          })}
        </div>
      </div>
      <Footer />
    </div>
    </Div100vh>
  );
}

export default App;

